import { render, staticRenderFns } from "./HowToTh.vue?vue&type=template&id=69892ec3&scoped=true&"
var script = {}
import style0 from "./HowToTh.vue?vue&type=style&index=0&id=69892ec3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69892ec3",
  null
  
)

export default component.exports